import FormularioButom from "./FormularioButom";
import FormularioInput from "./FormularioInput";
import FormularioList from "./FormularioList";
import { useEffect, useMemo, useState } from "react";
import "./FormularioComissao.css";
import Api from "../Services/Api";

const FormularioComissao = ({ licenciados = [], lancamentoAdicionado, modo="create", editId, lancamentoAtualizado }) => {
  useEffect(() => {
    if (modo !== "edit" || !editId) return;

    (async () => {
      try {
        const { data } = await Api.get(`/ledger-entries/${editId}`);

        setUserId(String(data.user_id || ""));
        setentry_type(data.entry_type || "");
        setStatus(data.status || "");

        setpurchase_date((data.purchase_date || "").slice(0,10));
        setclient_name(data.client_name || "");
        setNumeroPedido(data.order_number || "");
        setpurchase_amount(String(Number(data.purchase_amount || 0)));
        setcommission_percent(data.commission_percent == null ? "" : String(data.commission_percent));
        setdescription(data.description || "");
        setDataInclusao((data.entry_date || "").slice(0,10));
      } catch (e) {
        alert("Erro ao carregar lançamento.");
      }
    })();
  }, [modo, editId]);

  // ✅ listas no formato que o FormularioList exige: {label, value}
  const tipodelancamento = useMemo(
    () => [
      { label: "Crédito", value: "CREDIT" },
      { label: "Débito", value: "DEBIT" },
    ],
    []
  );

  const listastatus = useMemo(
    () => [
      { label: "Pendente", value: "PENDING" },
      { label: "Confirmado", value: "CONFIRMED" },
      { label: "Saque solicitado", value: "WITHDRAW_REQUESTED" },
    ],
    []
  );

  const listaLicenciados = useMemo(() => {
    return (licenciados || []).map((l) => ({
      label: l.name, // vem do backend {id, name}
      value: String(l.id),
    }));
  }, [licenciados]);

  // ✅ states agora guardam o VALUE real
  const [user_id, setUserId] = useState("");
  const [entry_type, setentry_type] = useState("");
  const [status, setStatus] = useState("");

  // inputs normais
  const [purchase_date, setpurchase_date] = useState("");
  const [client_name, setclient_name] = useState("");
  const [order_number, setNumeroPedido] = useState("");
  const [purchase_amount, setpurchase_amount] = useState("");
  const [commission_percent, setcommission_percent] = useState("");
  const [description, setdescription] = useState("");
  const [dataInclusao, setDataInclusao] = useState("");

  const aoSalvar = async (evento) => {
    evento.preventDefault();

    // =========================
    // 1) Validações
    // =========================
    if (!user_id) return alert("Selecione o licenciado.");
    if (!entry_type) return alert("Selecione o tipo de lançamento.");
    if (!status) return alert("Selecione o status.");

    if (!purchase_date) return alert("Informe a data da compra.");

    if (!purchase_amount || Number(purchase_amount) <= 0) {
        return alert("Informe o valor da compra/saque.");
    }

    // =========================
    // 2) Normalização
    // =========================
    const purchaseAmountNumber = Number(purchase_amount);
    const commissionPercentNumber =
        commission_percent === "" || commission_percent === null || commission_percent === undefined
        ? null
        : Number(commission_percent);

    // =========================
    // 3) Payload FINAL
    // =========================
    
    const payload = {
      user_id: Number(user_id),
      entry_type,
      purchase_amount: purchaseAmountNumber,
      commission_percent: commissionPercentNumber,
      purchase_date,
      entry_date: dataInclusao,
      client_name: client_name || null,
      order_number: order_number || null,
      description: description || null,
      origin: entry_type === "DEBIT" ? "WITHDRAW" : "COMMISSION",
      status,
    };

    // =========================
    // 4) Envio
    // =========================
    try {

      if (modo === "edit" && editId) {
        const { data } = await Api.put(`/ledger-entries/${editId}`, payload);
        lancamentoAtualizado?.(data);
      } else {
        const { data } = await Api.post("/ledger-entries", payload);
        lancamentoAdicionado?.(data);
      }
    } catch (err) {
        console.error("Erro ao salvar:", err?.response?.data || err.message);
        alert(err?.response?.data?.message || "Erro ao salvar lançamento.");
        return;
    }

    // =========================
    // 5) Limpa
    // =========================
    setUserId("");
    setentry_type("");
    setStatus("");
    setpurchase_date("");
    setclient_name("");
    setNumeroPedido("");
    setpurchase_amount("");
    setcommission_percent("");
    setdescription("");
    setDataInclusao("");
};


  return (
    <section className="card-comissao">
      <div className="card-header-comissao">
        <div>
          <div className="card-title">Novo lançamento</div>
          <div className="card-subtitle">
            Registre manualmente a comissão ou o saque no extrato do licenciado.
          </div>
        </div>
      </div>

      <form id="bank-form" className="lancamentoForm" noValidate onSubmit={aoSalvar}>
        {/* ✅ LICENCIADO */}
        <FormularioList
          itens={listaLicenciados}
          title="Licenciado"
          required="required"
          id="user_id"
          placeholder="Selecione"
          helper="Selecione o licenciado"
          lista="user_id"
          valor={user_id}
          aoAlterado={(v) => setUserId(v)}
        />

        {/* ✅ TIPO */}
        <FormularioList
          itens={tipodelancamento}
          title="Tipo de lançamento"
          required="required"
          id="entry_type"
          placeholder="Selecione"
          helper="Selecione o tipo de lançamento"
          lista="entry_type"
          valor={entry_type}
          aoAlterado={(v) => setentry_type(v)}
        />

        {/* ✅ STATUS */}
        <FormularioList
          itens={listastatus}
          title="Status"
          required="required"
          id="status"
          placeholder="Selecione"
          helper="Selecione o status"
          lista="status"
          valor={status}
          aoAlterado={(v) => setStatus(v)}
        />

        <FormularioInput
          type="date"
          size="quarto"
          title="Data da compra"
          required="required"
          id="dataCompra"
          placeholder="dd/mm/aaaa"
          helper="Informe a data de compra."
          valor={purchase_date}
          aoAlterado={(v) => setpurchase_date(v)}
        />

        <FormularioInput
          type="text"
          size="quarto"
          title="Cliente (nome ou referência)"
          required="required"
          id="cliente"
          placeholder="Cliente XPTO / Saque Licenciado"
          helper="Informe o nome do Cliente."
          valor={client_name}
          aoAlterado={(v) => setclient_name(v)}
        />

        <FormularioInput
          type="text"
          size="quarto"
          title="Nº da compra / saque"
          required="required"
          id="numeroPedido"
          placeholder="Ex: 12345 / SAQ-2026-001"
          helper="Informe o numero da compra."
          valor={order_number}
          aoAlterado={(v) => setNumeroPedido(v)}
        />

        <FormularioInput
          type="number"
          size="quarto"
          title="Valor da compra, ou saque (R$)"
          required="required"
          id="purchase_amount"
          placeholder="00,00"
          helper="Valor da compra."
          valor={purchase_amount}
          aoAlterado={(v) => setpurchase_amount(v)}
        />

        <FormularioInput
          type="number"
          size="quarto"
          title="Percentual de comissão (%)"
          id="commission_percent"
          placeholder="Ex: 18"
          helper="% de comissão."
          valor={commission_percent}
          aoAlterado={(v) => setcommission_percent(v)}
        />

        <FormularioInput
          type="text"
          size="quarto"
          title="Descrição"
          id="description"
          placeholder="Ex: Pedido #1234 – site, Saque solicitado 10/01/2026"
          helper="Informe uma descrição."
          valor={description}
          aoAlterado={(v) => setdescription(v)}
        />

        <FormularioInput
          type="date"
          size="quarto"
          title="Data da inclusão do lançamento"
          required="required"
          id="dataInclusao"
          placeholder="dd/mm/aaaa"
          helper="Informe a data de inclusão."
          valor={dataInclusao}
          aoAlterado={(v) => setDataInclusao(v)}
        />

        <div style={{ display:"flex", gap: 10 }}>
          <FormularioButom icone="💾">
            {modo === "edit" ? "Salvar alterações" : "Salvar lançamento"}
          </FormularioButom>
        </div>
      </form>
    </section>
  );
};

export default FormularioComissao;
